export default __webpack_public_path__ + "static/media/V720MAND2.cdadabae.pdf";